import React, { ChangeEvent } from "react";
import { useDispatch } from "react-redux";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import GreenCheckbox from "components/GreenCheckbox";
import { transformViewDate } from "utils/date-utils";

import { setIsUseLastExamEntry } from "store/actions/vetExam";
import { useAppSelector } from "hooks/redux/useAppSelector";

import { getCombinedLocalStateExam, getResetLocalStateExam } from "../helper";
import { useVetExamContext } from "../VetExamProvider/VetExamProvider";

import useStyles from "./styles";

interface IProps {
  completedExams: racehorse360.IHorseExam[];
}

const CloneLastExamEntry = ({ completedExams }: IProps) => {
  const lastExam = completedExams?.[0];

  const classes = useStyles();
  const dispatch = useDispatch();
  const { currentExam, setValues } = useVetExamContext();
  const isUseLastExamEntry = useAppSelector(
    state => state.vetExam?.isUseLastExamEntry
  );

  const handleUseLastExamEntryChange = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (!completedExams?.length) return;

    if (event.target.checked) {
      setValues(getCombinedLocalStateExam(currentExam, completedExams[0]));
    } else {
      setValues(getResetLocalStateExam(currentExam));
    }

    dispatch(setIsUseLastExamEntry(event.target.checked));
  };

  const checkboxCaption = lastExam ? (
    <>
      Use Last Exam Entry&nbsp;
      <span className={classes.italic}>
        (
        {transformViewDate(
          lastExam.completedDate,
          lastExam.facility.timezone,
          "M/d/yy"
        )}
        )
      </span>
    </>
  ) : (
    <span className={classes.italic}>No Past Exams</span>
  );

  return (
    <div className={classes.useLastExamEntryCheckboxContainer}>
      <label
        className={clsx(classes.useLastExamEntryCheckboxLabel, {
          [classes.noPastExams]: !lastExam
        })}
      >
        {checkboxCaption}
        <GreenCheckbox
          checked={isUseLastExamEntry}
          disabled={!lastExam}
          onChange={handleUseLastExamEntryChange}
        />
      </label>
    </div>
  );
};

export default React.memo(CloneLastExamEntry);
